import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BottomNav, { bottomNavVisible } from '../components/BottomNav';

const MainLayout: React.FC = () => {
  const { pathname } = useLocation();
  // Platz für die Bottom-Navbar auf Mobile (2026-09-26), nur wo sie sichtbar ist
  const withBottomNav = bottomNavVisible(pathname);
  return (
    <div className={`flex min-h-screen flex-col bg-black ${withBottomNav ? 'pb-[52px] md:pb-0' : ''}`}>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BottomNav />
    </div>
  );
};

export default MainLayout;
